<div class="bg-white">
  <div class="border-bottom p-4">
    <h3>{{ 'Sellers.Products.AddQuickCash' | translate }}</h3>
  </div>

  <div class="p-4">
    <div class="container">
      <form [formGroup]="stepForm" *ngIf="stepForm">
        <div class="row justify-content-end">
          <div class="col-md-4 mb-3">
            <app-product-name [fieldObject]="controllers['Title']"
                              [fieldErrors]="formValidator.formErrors"
                              [formControlRef]="convertControls(controllers['Title'].fieldName)"
                              [productType]="productTypeId"
                              [isUpdate]="isUpdate"></app-product-name>
          </div>
          <div class="col-md-4 mb-3">
            <app-number [fieldObject]="controllers['Amount']"
                        [fieldErrors]="formValidator.formErrors"
                        [formControlRef]="convertControls(controllers['Amount'].fieldName)"
                        [productType]="productTypeId"
                        [isUpdate]="isUpdate"></app-number>
          </div>
          <div class="col-md-4 mt-1 mb-3">
            <app-select-list [fieldObject]="controllers['Cash Type']"
                             [fieldErrors]="formValidator.formErrors"
                             [formControlRef]="convertControls('Cash Type')"
                             [productType]="productTypeId"
                             [isUpdate]="isUpdate"
                             (selectedTypeEvent)="onCashTypeSelect($event)"></app-select-list>
          </div>
          <div class="col-md-6 mb-3">
            <app-text [fieldObject]="controllers['Name']"
                      [fieldErrors]="formValidator.formErrors"
                      [formControlRef]="convertControls('Name')"
                      [productType]="productTypeId"
                      [isUpdate]="isUpdate"></app-text>

          </div>
          <div class="col-md-6 mb-3">
            <app-text [fieldObject]="controllers['Payer Email']"
                      [fieldErrors]="formValidator.formErrors"
                      [formControlRef]="convertControls('Payer Email')"
                      [productType]="productTypeId"
                      [isUpdate]="isUpdate"></app-text>

          </div>
          <div class="col-md-6 mb-3">
            <app-text [fieldObject]="controllers['Payer Mobile Number']"
                      [fieldErrors]="formValidator.formErrors"
                      [formControlRef]="convertControls('Payer Mobile Number')"
                      [productType]="productTypeId"
                      [isUpdate]="isUpdate"></app-text>
          </div>
          <div class="col-md-6 mt-1 mb-3" *ngIf="isCashTypeReceived">
            <app-select-list [fieldObject]="controllers['Cash Expiry Duration']"
                             [fieldErrors]="formValidator.formErrors"
                             [formControlRef]="convertControls('Cash Expiry Duration')"
                             [productType]="productTypeId"
                             [isUpdate]="isUpdate"></app-select-list>
          </div>
          <div class="col-md-12 mb-3">
            <app-text-area [fieldObject]="controllers['Description']"
                           [fieldErrors]="formValidator.formErrors"
                           [formControlRef]="convertControls(controllers['Description'].fieldName)"
                           [productType]="productTypeId"
                           [isUpdate]="isUpdate"></app-text-area>
          </div>
          <div class="col-auto">
            <button class="btn btn-primary" type="button" [disabled]="!stepForm.valid"
                    (click)="submit()">
              {{ 'Sellers.Products.Submit' | translate }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
